
export const getSession= (data)=>{
    return{
        type: 'GETSESSION',
        data
    }
}


